import { Component} from '@angular/core';

@Component({
    selector: 'app-footer-bar',
    templateUrl: './footer-bar.component.html',
})
export class FooterBarComponent { 
    constructor() {
    }
}



// WEBPACK FOOTER //
// ./src/app/components/shared/footer-bar/footer-bar.component.ts